export const getNoticePeriodToDays = (value: string) => {
  if (value === "Serving Notice Period") {
    return "0";
  } else if (value === "Immediately available") {
    return "1";
  } else if (value === "15 days") {
    return "15";
  } else if (value === "30 days") {
    return "30";
  } else if (value === "45 days") {
    return "45";
  } else if (value === "2 months") {
    return "60";
  } else if (value === "3 months") {
    return "90";
  } else if (value === "6 months") {
    return "180";
  }
  return "0";
};

export const getNoticePeriodFromDays = (
  noticePeriodDays?: number,
  isServing?: boolean,
) => {
  if (isServing) {
    return "Serving Notice Period";
  } else if ((noticePeriodDays === 0 || noticePeriodDays === 1) && !isServing) {
    return "Immediately available";
  } else if (noticePeriodDays === 15) {
    return "15 days";
  } else if (noticePeriodDays === 30) {
    return "30 days";
  } else if (noticePeriodDays === 45) {
    return "45 days";
  } else if (noticePeriodDays === 60) {
    return "2 months";
  } else if (noticePeriodDays === 90) {
    return "3 months";
  } else {
    return "6 months";
  }
};
